<template>
    <div>You should have an <code>inline-template</code> directive on the component</div>
</template>
<script>
  import normalize from "json-api-normalize";
  import Attributes from "../../../models/Attributes";

  export default {
    props: ['serialized_plans', 'serialized_products', 'csv_payout_data'],

    data() {
      return {
        plans: normalize(JSON.parse(this.serialized_plans)).get(Attributes.plansAttributes),
        products: normalize(JSON.parse(this.serialized_products)).get(Attributes.productAttributes),
        csvProducts: JSON.parse(this.csv_payout_data),
        selectedPrice: null,
        unitPrice: 0,
        assetsCount: 0,
        selectedPlanId: null,
        payoutData: null
      }
    },

    watch: {
      assetsCount(number) {
        const n = parseInt(number, 10)
        if (!isNaN(n) && this.selectedPrice) {
          const interval = this.selectedPrice.interval === 'year' ? 'annual' : 'monthly'
          // console.log(`Searching for ${interval}, ${n}, ${this.selectedProductType}`);
          const data = this.csvProducts.find(d => {
            return d.interval === interval && d.asset_count === n && d.type === this.selectedProductType
          })

          this.payoutData = data

          if (data) {
            this.unitPrice = data.unit
          }

        }
      },

      selectedPrice(price) {
        if (price) {
          // this.unitPrice = (price.amount / 1000 / price.quantity).toFixed(2)
          this.assetsCount = price.quantity
          const plan = this.plans.find(p => p.prices.includes(price))

          if (plan) {
            const product = this.products.find(p => p.identifier === plan.identifier)
            if (product) {
              this.selectedPlanId = product.id
            }
          }

        }
      }
    },

    computed: {
      selectedProductType() {
        const plan = this.plans.find(p => p.prices.includes(this.selectedPrice))
        if (plan) {
          return plan.identifier
        }
        return null
      },

      planOptions() {
        return this.plans.map(plan => {
          return {
            label: `${plan.product_name} - ${plan.interval}`,
            options: plan.prices.map(price => {
              return {
                value: price,
                text: `${price.name} - $${price.amount / 100}/${price.interval}`
              }
            })
          }
        })
      }
    }
  }
</script>